import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const EnergyClassIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 22 20" fill="none" {...props}>
    <g clipPath="url(#clip0_13727_5235)">
      <path
        d="M0.00536585 13.897C1.37902 13.9078 2.75268 13.8862 4.12634 13.897C9.09512 13.9348 14.08 14.0375 19.0488 14.0916C19.9127 14.8754 20.7605 15.724 21.5922 16.5565C21.9785 17.0592 21.662 17.3457 21.3078 17.697C20.6317 18.3727 19.8483 18.9457 19.1883 19.643C19.1346 19.697 19.0702 19.724 18.9951 19.7348C18.6624 19.7889 18.04 19.7457 17.6751 19.7348C12.878 19.6538 8.07024 19.5997 3.27317 19.5403C2.32878 19.5294 1.05707 19.6484 0.160976 19.5403C0.112683 19.5348 0 19.5186 0 19.4646V13.8916L0.00536585 13.897ZM1.13756 18.3997C1.71171 18.4105 2.28585 18.3835 2.86 18.3997C7.65707 18.5024 12.4649 18.5078 17.262 18.5943C17.5249 18.5943 18.4746 18.6375 18.6517 18.5673C18.6839 18.5511 18.8449 18.4213 18.8878 18.3781C19.3976 17.9457 19.859 17.4105 20.3956 16.9997C19.8429 16.3403 19.1883 15.7294 18.5337 15.1781C15.4376 15.2105 12.3468 15.1078 9.26146 15.0808C6.55171 15.0538 3.84732 15.0646 1.13756 15.0375V18.4051V18.3997Z"
        fill="currentColor"
      />

      <path
        d="M0.0537109 7.02051H15.5664L18.0615 9.48537C18.3996 9.92862 18.2064 10.1989 17.8737 10.5286C17.144 11.2638 16.2586 11.9286 15.5181 12.6638H0.123467C0.123467 12.6638 0.0537109 12.5989 0.0537109 12.5935V7.02051ZM15.0459 8.10699H1.25566C1.25566 8.10699 1.18591 8.17186 1.18591 8.17726V11.5232H15.0996L16.8649 9.93402C16.8649 9.80429 15.2713 8.3124 15.0513 8.10699H15.0459Z"
        fill="currentColor"
      />

      <path
        d="M0.0751273 0H11.4668L14.0102 2.51351C14.2356 2.76757 14.2356 3.11892 14.0102 3.36757L11.4668 5.69189H0.0751273C0.0751273 5.69189 0.00537109 5.62703 0.00537109 5.62162V0.0702703C0.00537109 0.0702703 0.0590297 0.0216216 0.0751273 0ZM1.13757 4.55135H11.0483L12.8137 2.91351L11 1.13514H1.13757V4.55135Z"
        fill="currentColor"
      />
    </g>

    <defs>
      <clipPath id="clip0_13727_5235">
        <rect width="22" height="20" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);
